import React from "react";

const fmtTime12 = (v) => {
  const s = String(v || "");
  const t = s.includes("T") ? s.split("T")[1] : (s.includes(" ") ? s.split(" ")[1] : s);
  const hhmm = String(t || "").slice(0, 5);
  if (!/^[0-2][0-9]:[0-5][0-9]$/.test(hhmm)) return hhmm || "";
  let h = Number(hhmm.slice(0, 2));
  const m = hhmm.slice(3, 5);
  const ampm = h >= 12 ? "PM" : "AM";
  h = h % 12;
  if (h === 0) h = 12;
  return `${h}:${m} ${ampm}`;
};

const CalendarMonthView = ({
  monthGridDays,
  apptsByDate,
  todayYMD,
  anchorDate,
  monthLabel,
  openNewForDate,
  openDayForDate,
  openEdit,
  fmtYMD,
  styles,
  isMobile,
}) => {
  const showCount = isMobile ? 1 : 3;

  return (
    <div className="jf-calendar-month-board" style={{ ...styles.board, ...(isMobile ? { borderLeftWidth: 0, borderRightWidth: 0, paddingLeft: 0, paddingRight: 0, marginLeft: -14, marginRight: -14, width: "calc(100% + 28px)", borderRadius: 0 } : {}) }}>
      <style>{`
        @media (max-width: 767px) {
          .jf-calendar-month-board {
            margin-left: -6px !important;
            margin-right: -6px !important;
            width: calc(100% + 12px) !important;
            padding-left: 5px !important;
            padding-right: 5px !important;
          }
        }
      `}</style>
      <div style={{ ...styles.boardInner, ...(isMobile ? { paddingLeft: 4, paddingRight: 4 } : {}) }}>
        <div style={{ fontWeight: 900, marginBottom: 10 }}>{monthLabel}</div>

        {/* Mobile-safe horizontal scroll for month grid */}
        <div style={{ width: "100%", overflowX: "auto", WebkitOverflowScrolling: "touch" }}>
          <div style={{ ...styles.monthGrid, gap: isMobile ? 2 : styles.monthGrid.gap, minWidth: "100%" }}>
            {["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"].map((dn) => (
              <div key={dn} style={{ fontWeight: 900, opacity: 0.9, paddingLeft: isMobile ? 0 : 6, textAlign: isMobile ? "center" : "left", fontSize: isMobile ? 10 : undefined }}>
                {isMobile ? dn.slice(0, 1) : dn}
              </div>
            ))}

            {monthGridDays.map((d) => {
              const key = fmtYMD(d);
              const list = apptsByDate[key] || [];
              const spanList = list.filter((a) => a.isMultiDay);
              const regularList = list.filter((a) => !a.isMultiDay);
              const shownSpans = spanList.slice(0, showCount);
              const remainingSlots = Math.max(0, showCount - shownSpans.length);
              const shownRegular = regularList.slice(0, remainingSlots);
              const hiddenCount = list.length - shownSpans.length - shownRegular.length;
              const isToday = key === todayYMD;
              const inMonth = d.getMonth() === anchorDate.getMonth();

              return (
                <div
                  key={key}
                  style={{
                    ...styles.monthCell(isToday),
                    ...(isMobile ? { padding: 3, minHeight: 64, borderWidth: 2, borderRadius: 8 } : { minHeight: 88 }),
                    opacity: inMonth ? 1 : 0.55,
                    cursor: "pointer",
                  }}
                  onClick={() => openNewForDate(d)}
                >
                  <div style={{ ...styles.monthTop, ...(isMobile ? { marginBottom: 3 } : {}) }}>
                    {isMobile ? (
                      <button
                        type="button"
                        aria-label={`Open day ${key}`}
                        style={{ ...styles.monthNum, width: 32, minWidth: 32, height: 30, margin: -3, padding: 0, border: 0, borderRadius: 6, background: "transparent", color: "inherit", fontSize: 12, cursor: "pointer" }}
                        onClick={(e) => {
                          e.stopPropagation();
                          openDayForDate(d);
                        }}
                      >
                        {d.getDate()}
                      </button>
                    ) : (
                      <button
                        type="button"
                        aria-label={`Open day ${key}`}
                        style={{ ...styles.monthNum, border: 0, padding: 0, background: "transparent", color: "inherit", font: "inherit", cursor: "pointer" }}
                        onClick={(e) => {
                          e.stopPropagation();
                          openDayForDate(d);
                        }}
                      >
                        {d.getDate()}
                      </button>
                    )}
                  </div>

                  <div style={styles.monthList}>
                    {shownSpans.map((a) => (
                      <div
                        key={`span-${a.id}`}
                        style={{
                          border: `${isMobile ? 1 : 2}px solid #E8E2DA`,
                          borderRadius: isMobile ? 4 : 8,
                          background: a.job_type_color || "white",
                          color: "black",
                          padding: isMobile ? "1px" : "2px 4px",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          gap: isMobile ? 1 : 4,
                          overflow: "hidden",
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          openEdit(a);
                        }}
                      >
                        {(a.isSpanMiddle || a.isSpanEnd) ? <span style={{ fontWeight: 900, fontSize: isMobile ? 7 : 11, flexShrink: 0 }}>◀</span> : null}
                        <div style={{ fontWeight: 900, fontSize: isMobile ? 8 : 11, lineHeight: 1.15, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", flex: 1 }}>
                          {(a.isSpanStart || a.isSpanEnd) ? (String(a.customer_name || "").trim() || "(customer)") : "────"}
                        </div>
                        {(a.isSpanStart || a.isSpanMiddle) ? <span style={{ fontWeight: 900, fontSize: isMobile ? 7 : 11, flexShrink: 0 }}>▶</span> : null}
                      </div>
                    ))}

                    {shownRegular.map((a) => (
                      <div
                        key={a.id}
                        style={{
                          border: `${isMobile ? 1 : 2}px solid #E8E2DA`,
                          borderRadius: isMobile ? 4 : 8,
                          background: a.job_type_color || "white",
                          color: "black",
                          padding: isMobile ? "1px" : "3px 4px",
                          cursor: "pointer",
                          position: "relative",
                          overflow: "hidden",
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          openEdit(a);
                        }}
                      >
                        <div style={{ ...styles.empStripe(a.employee_color), ...(isMobile ? { width: 3, borderRightWidth: 1 } : {}) }} />

                        <div style={{ fontWeight: 900, marginLeft: 9, fontSize: 12, lineHeight: 1.05, ...(isMobile ? { marginLeft: 4, fontSize: 8, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" } : { overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }) }}>
                          {isMobile
                            ? (a.start_hhmm ? fmtTime12(a.start_hhmm) : fmtTime12(a.start_time))
                                .replace(":00", "").replace(" AM", "a").replace(" PM", "p")
                            : <>{(a.start_hhmm ? fmtTime12(a.start_hhmm) : fmtTime12(a.start_time))} •{" "}{String(a.customer_name || "").trim() || "(customer)"}</>}
                        </div>

                        {/* Optional 2nd line, compact */}
                        <div style={{ fontWeight: 900, marginLeft: 9, fontSize: 10, lineHeight: 1.05, opacity: 0.85, marginTop: 1, ...(isMobile ? { marginLeft: 4, fontSize: 7, lineHeight: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" } : { overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }) }}>
                          {isMobile ? (String(a.customer_name || "").trim() || "(customer)") : (String(a.title || "").trim() || "")}
                        </div>
                      </div>
                    ))}

                    {hiddenCount > 0 ? (
                      <button
                        type="button"
                        style={{ width: "100%", minHeight: isMobile ? 22 : undefined, marginTop: isMobile ? -4 : 0, padding: isMobile ? "2px 0" : 0, border: 0, borderRadius: isMobile ? 5 : 0, background: "transparent", color: "inherit", font: "inherit", fontWeight: 900, opacity: isMobile ? 1 : 0.9, fontSize: isMobile ? 10 : 12, lineHeight: isMobile ? 1.1 : undefined, whiteSpace: "nowrap", textAlign: "center", cursor: "pointer" }}
                      >
                        +{hiddenCount}
                      </button>
                    ) : null}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CalendarMonthView;
